import { Sparkle, Money } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import RiskBadge from "@/components/RiskBadge";
import StatusBadge from "@/components/StatusBadge";
import { fmtCurrency as fmt } from "@/lib/format";

export default function DebtorHeader({ debtor, onReclassify, classifying, onAbono }) {
  const original = Number(debtor.monto_original || debtor.monto_deuda || 0);
  const abonado = Number(debtor.total_abonado || 0);
  const saldo = Number(
    debtor.saldo_pendiente != null && debtor.saldo_pendiente !== ""
      ? debtor.saldo_pendiente
      : original
  );
  const pct = original > 0 ? Math.min(100, (abonado / original) * 100) : 0;
  const saldado = saldo <= 0.01;

  return (
    <div className="bg-card border border-border rounded-md p-6 flex flex-col md:flex-row md:items-start md:justify-between gap-4" data-testid="debtor-header">
      <div>
        <div className="overline">Deudor #{debtor.id.slice(0, 8)}</div>
        <h2 className="font-heading text-3xl font-semibold tracking-tight mt-1">
          {debtor.cliente_nombre}
        </h2>
        <div className="flex flex-wrap gap-3 mt-3 text-sm text-muted-foreground">
          <span>{debtor.email}</span>
          <span>·</span>
          <span>{debtor.telefono}</span>
        </div>
        <div className="flex gap-2 mt-4">
          <RiskBadge risk={debtor.risk} />
          <StatusBadge status={debtor.status} />
        </div>
        {debtor.risk_reason && (
          <p className="text-xs text-muted-foreground mt-3 italic max-w-xl">
            {debtor.risk_reason}
          </p>
        )}
      </div>
      <div className="text-right md:min-w-[260px]">
        <div className="overline">Saldo pendiente</div>
        <div
          className={`font-heading text-4xl font-semibold font-mono ${saldado ? "text-success" : "text-destructive"}`}
          data-testid="debtor-header-saldo"
        >
          {fmt(saldo)}
        </div>
        <div className="text-xs text-muted-foreground mt-1">
          Original {fmt(original)} · Abonado {fmt(abonado)}
        </div>
        <Progress value={pct} className="h-1.5 mt-2" />
        <div className="text-sm text-muted-foreground mt-2">
          {debtor.dias_vencimiento} días de atraso
        </div>
        <div className="mt-3 flex gap-2 justify-end flex-wrap">
          <Button
            variant="outline"
            size="sm"
            onClick={onReclassify}
            disabled={classifying}
            data-testid="reclassify-btn"
          >
            <Sparkle size={14} weight="duotone" className="mr-1.5" />
            {classifying ? "Analizando…" : "Reanalizar con IA"}
          </Button>
          <Button
            size="sm"
            onClick={onAbono}
            disabled={saldado}
            data-testid="detail-abono-btn"
          >
            <Money size={14} weight="duotone" className="mr-1.5" />
            {saldado ? "Saldada" : "Registrar abono"}
          </Button>
        </div>
      </div>
    </div>
  );
}
